import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IntPhoneInputComponent} from "./int-phone-input.component";
import {IntInputModule} from "../../int-input/int-input.module";
import {IntSelectModule} from "../../int-select/int-select.module";

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IntInputModule, IntSelectModule],
  declarations: [IntPhoneInputComponent],
  exports: [IntPhoneInputComponent]
})
export class IntPhoneInputModule {}
